export const splitLocale = (locale: string) => {
  const normalizedLocale = locale.replace('-', '_').toLowerCase();
  const localeData = normalizedLocale.split('_');
  const language = localeData[0];
  const country = localeData[1];

  return {
    locale: normalizedLocale,
    language,
    country: country ? country : language, //in case country and language are same like en
  };
};
